


import { useState, useEffect } from 'react';
import { supabase } from '../../../supabaseClient'; // Ajuste o caminho do client se necessário

export function useVideoMetrics(videoId: string, initialViews?: number, initialLikes?: number) {
  const [likes, setLikes] = useState<number>(initialLikes ?? 0);
  const [hasLiked, setHasLiked] = useState(false);
  const [views, setViews] = useState<number>(initialViews ?? 0);
  const [commentsCount, setCommentsCount] = useState<number>(0);

  useEffect(() => {
    if (!videoId) return;
    let isMounted = true;

    const fetchMetrics = async () => {
      try {
        // Puxa dados frescos do vídeo
        const { data: videoData } = await supabase
          .from('videos')
          .select('views_count, likes_count')
          .eq('id', videoId)
          .single();

        // Puxa contagem real de comentários
        const { count: realCommentsCount } = await supabase
          .from('comments')
          .select('*', { count: 'exact', head: true })
          .eq('video_id', videoId);

        if (isMounted) {
          const currentViews = videoData?.views_count ?? initialViews ?? 0;
          const newViews = currentViews + 1;

          setLikes(videoData?.likes_count ?? initialLikes ?? 0);
          setViews(newViews);
          setCommentsCount(realCommentsCount ?? 0);

          // Verifica se o usuário já curtiu via localStorage
          const savedLikes = JSON.parse(localStorage.getItem('doisplay_likes') || '[]');
          setHasLiked(savedLikes.includes(videoId));

          // Incrementa a visualização no banco via RPC
          await supabase.rpc('increment_view', { vid_id: videoId });
        }
      } catch (err) {
        console.error("Erro ao carregar métricas do vídeo:", err);
      }
    };

    fetchMetrics();

    return () => {
      isMounted = false;
    };
  }, [videoId, initialViews, initialLikes]); // <-- ADICIONADO initialViews e initialLikes aqui para satisfazer o TypeScript

  // Função para lidar com o Like/Deslike
  const handleLike = async () => {
    let savedLikes = JSON.parse(localStorage.getItem('doisplay_likes') || '[]');

    if (hasLiked) {
      const newLikes = likes > 0 ? likes - 1 : 0;
      setLikes(newLikes);
      setHasLiked(false);
      savedLikes = savedLikes.filter((id: string) => id !== videoId);
      localStorage.setItem('doisplay_likes', JSON.stringify(savedLikes));
      await supabase.rpc('update_like', { vid_id: videoId, amount: -1 });
    } else {
      const newLikes = likes + 1;
      setLikes(newLikes);
      setHasLiked(true);
      if (!savedLikes.includes(videoId)) {
        savedLikes.push(videoId);
        localStorage.setItem('doisplay_likes', JSON.stringify(savedLikes));
      }
      await supabase.rpc('update_like', { vid_id: videoId, amount: 1 });
      try {
        await supabase.from('video_likes').insert([{ video_id: videoId }]);
      } catch (err) { }
    }
  };

  return {
    likes,
    hasLiked,
    views,
    commentsCount,
    handleLike
  };
}